import { request } from './client';

export type SectionActivity = {
	id: number;
	program_id: number;
	template_id: number | null;
	is_from_library: boolean;
	schema: { version: string; fields: Array<Record<string, unknown>> };
	settings: { title?: string; [key: string]: unknown };
	week: number;
	day: number;
	position: number;
	created_at: string;
};

export type Section = {
	id: number;
	program_id: number;
	title: string;
	description: string;
	position: number;
	created_at: string;
	activities: SectionActivity[];
};

export const sectionsApi = {
	list: (programId: number) =>
		request<{ sections: Section[] }>(`/programs/${programId}/sections`),

	create: (programId: number, data: { title: string; description?: string }) =>
		request<Section>(`/programs/${programId}/sections`, {
			method: 'POST',
			data,
		}),

	reorder: (programId: number, order: number[]) =>
		request<{ reordered: boolean }>(`/programs/${programId}/sections`, {
			method: 'PATCH',
			data: { order },
		}),

	update: (
		programId: number,
		sectionId: number,
		data: { title?: string; description?: string },
	) =>
		request<Section>(`/programs/${programId}/sections/${sectionId}`, {
			method: 'POST',
			data,
		}),

	delete: (programId: number, sectionId: number) =>
		request<{ deleted: boolean; id: number }>(
			`/programs/${programId}/sections/${sectionId}`,
			{ method: 'DELETE' },
		),

	createActivity: (
		programId: number,
		sectionId: number,
		data: { schema: object; settings?: object },
	) =>
		request<SectionActivity>(
			`/programs/${programId}/sections/${sectionId}/activities`,
			{ method: 'POST', data },
		),

	reorderActivities: (
		programId: number,
		sectionId: number,
		activityIds: number[],
	) =>
		request<{ reordered: boolean }>(
			`/programs/${programId}/sections/${sectionId}/activities/order`,
			{ method: 'PATCH', data: { activity_ids: activityIds } },
		),
};

export const programActivitiesApi = {
	delete: (programId: number, activityId: number) =>
		request<{ deleted: boolean; id: number }>(
			`/programs/${programId}/activities/${activityId}`,
			{ method: 'DELETE' },
		),
};
